export type Maybe<T> = T | null;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: Date;
  /* eslint-disable @typescript-eslint/no-explicit-any */
  Json: any;
  Upload: any;
  Long: any;
  /* eslint-enable @typescript-eslint/no-explicit-any */
};

export type Query = {
  __typename?: 'Query';
  design?: Maybe<Design>;
  designs: Array<Maybe<Design>>;
  designsConnection: DesignConnection;
  designLayer?: Maybe<DesignLayer>;
  designLayers: Array<Maybe<DesignLayer>>;
  designLayersConnection: DesignLayerConnection;
  font?: Maybe<Font>;
  fonts: Array<Maybe<Font>>;
  fontsConnection: FontConnection;
};

export type QueryDesignArgs = {
  where: DesignWhereUniqueInput;
};

export type QueryDesignsArgs = {
  where?: Maybe<DesignWhereInput>;
  orderBy?: Maybe<DesignOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type QueryDesignsConnectionArgs = {
  where?: Maybe<DesignWhereInput>;
  orderBy?: Maybe<DesignOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type QueryDesignLayerArgs = {
  where: DesignLayerWhereUniqueInput;
};

export type QueryDesignLayersArgs = {
  where?: Maybe<DesignLayerWhereInput>;
  orderBy?: Maybe<DesignLayerOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type QueryDesignLayersConnectionArgs = {
  where?: Maybe<DesignLayerWhereInput>;
  orderBy?: Maybe<DesignLayerOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type QueryFontArgs = {
  where: FontWhereUniqueInput;
};

export type QueryFontsArgs = {
  where?: Maybe<FontWhereInput>;
  orderBy?: Maybe<FontOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type QueryFontsConnectionArgs = {
  where?: Maybe<FontWhereInput>;
  orderBy?: Maybe<FontOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type DesignWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type Design = {
  __typename?: 'Design';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  type: DesignType;
  dimensions: Scalars['Json'];
  digitalSize: Scalars['Json'];
  layers?: Maybe<Array<DesignLayer>>;
};

export type DesignLayersArgs = {
  where?: Maybe<DesignLayerWhereInput>;
  orderBy?: Maybe<DesignLayerOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export enum DesignType {
  Canvas = 'CANVAS',
  Behang = 'BEHANG',
}

export type DesignLayerWhereInput = {
  id?: Maybe<Scalars['ID']>;
  id_not?: Maybe<Scalars['ID']>;
  id_in?: Maybe<Array<Scalars['ID']>>;
  id_not_in?: Maybe<Array<Scalars['ID']>>;
  id_lt?: Maybe<Scalars['ID']>;
  id_lte?: Maybe<Scalars['ID']>;
  id_gt?: Maybe<Scalars['ID']>;
  id_gte?: Maybe<Scalars['ID']>;
  id_contains?: Maybe<Scalars['ID']>;
  id_not_contains?: Maybe<Scalars['ID']>;
  id_starts_with?: Maybe<Scalars['ID']>;
  id_not_starts_with?: Maybe<Scalars['ID']>;
  id_ends_with?: Maybe<Scalars['ID']>;
  id_not_ends_with?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAt_not?: Maybe<Scalars['DateTime']>;
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt_lt?: Maybe<Scalars['DateTime']>;
  updatedAt_lte?: Maybe<Scalars['DateTime']>;
  updatedAt_gt?: Maybe<Scalars['DateTime']>;
  updatedAt_gte?: Maybe<Scalars['DateTime']>;
  design?: Maybe<DesignWhereInput>;
  type?: Maybe<DesignLayerType>;
  type_not?: Maybe<DesignLayerType>;
  type_in?: Maybe<Array<DesignLayerType>>;
  type_not_in?: Maybe<Array<DesignLayerType>>;
  image?: Maybe<Scalars['String']>;
  image_not?: Maybe<Scalars['String']>;
  image_in?: Maybe<Array<Scalars['String']>>;
  image_not_in?: Maybe<Array<Scalars['String']>>;
  image_lt?: Maybe<Scalars['String']>;
  image_lte?: Maybe<Scalars['String']>;
  image_gt?: Maybe<Scalars['String']>;
  image_gte?: Maybe<Scalars['String']>;
  image_contains?: Maybe<Scalars['String']>;
  image_not_contains?: Maybe<Scalars['String']>;
  image_starts_with?: Maybe<Scalars['String']>;
  image_not_starts_with?: Maybe<Scalars['String']>;
  image_ends_with?: Maybe<Scalars['String']>;
  image_not_ends_with?: Maybe<Scalars['String']>;
  AND?: Maybe<Array<DesignLayerWhereInput>>;
  OR?: Maybe<Array<DesignLayerWhereInput>>;
  NOT?: Maybe<Array<DesignLayerWhereInput>>;
};

export type DesignWhereInput = {
  id?: Maybe<Scalars['ID']>;
  id_not?: Maybe<Scalars['ID']>;
  id_in?: Maybe<Array<Scalars['ID']>>;
  id_not_in?: Maybe<Array<Scalars['ID']>>;
  id_lt?: Maybe<Scalars['ID']>;
  id_lte?: Maybe<Scalars['ID']>;
  id_gt?: Maybe<Scalars['ID']>;
  id_gte?: Maybe<Scalars['ID']>;
  id_contains?: Maybe<Scalars['ID']>;
  id_not_contains?: Maybe<Scalars['ID']>;
  id_starts_with?: Maybe<Scalars['ID']>;
  id_not_starts_with?: Maybe<Scalars['ID']>;
  id_ends_with?: Maybe<Scalars['ID']>;
  id_not_ends_with?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAt_not?: Maybe<Scalars['DateTime']>;
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt_lt?: Maybe<Scalars['DateTime']>;
  updatedAt_lte?: Maybe<Scalars['DateTime']>;
  updatedAt_gt?: Maybe<Scalars['DateTime']>;
  updatedAt_gte?: Maybe<Scalars['DateTime']>;
  type?: Maybe<DesignType>;
  type_not?: Maybe<DesignType>;
  type_in?: Maybe<Array<DesignType>>;
  type_not_in?: Maybe<Array<DesignType>>;
  layers_every?: Maybe<DesignLayerWhereInput>;
  layers_some?: Maybe<DesignLayerWhereInput>;
  layers_none?: Maybe<DesignLayerWhereInput>;
  AND?: Maybe<Array<DesignWhereInput>>;
  OR?: Maybe<Array<DesignWhereInput>>;
  NOT?: Maybe<Array<DesignWhereInput>>;
};

export enum DesignLayerType {
  Background = 'Background',
  Text = 'Text',
  Image = 'Image',
}

export enum DesignLayerOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC',
  PositionAsc = 'position_ASC',
  PositionDesc = 'position_DESC',
  DimensionsAsc = 'dimensions_ASC',
  DimensionsDesc = 'dimensions_DESC',
  AttributesAsc = 'attributes_ASC',
  AttributesDesc = 'attributes_DESC',
  ImageAsc = 'image_ASC',
  ImageDesc = 'image_DESC',
}

export type DesignLayer = {
  __typename?: 'DesignLayer';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  design: Design;
  type: DesignLayerType;
  position: Scalars['Json'];
  dimensions: Scalars['Json'];
  attributes: Scalars['Json'];
  image?: Maybe<Scalars['String']>;
};

export enum DesignOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC',
  DimensionsAsc = 'dimensions_ASC',
  DimensionsDesc = 'dimensions_DESC',
  DigitalSizeAsc = 'digitalSize_ASC',
  DigitalSizeDesc = 'digitalSize_DESC',
}

export type DesignConnection = {
  __typename?: 'DesignConnection';
  pageInfo: PageInfo;
  edges: Array<Maybe<DesignEdge>>;
  aggregate: AggregateDesign;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
  endCursor?: Maybe<Scalars['String']>;
};

export type DesignEdge = {
  __typename?: 'DesignEdge';
  node: Design;
  cursor: Scalars['String'];
};

export type AggregateDesign = {
  __typename?: 'AggregateDesign';
  count: Scalars['Int'];
};

export type DesignLayerWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type DesignLayerConnection = {
  __typename?: 'DesignLayerConnection';
  pageInfo: PageInfo;
  edges: Array<Maybe<DesignLayerEdge>>;
  aggregate: AggregateDesignLayer;
};

export type DesignLayerEdge = {
  __typename?: 'DesignLayerEdge';
  node: DesignLayer;
  cursor: Scalars['String'];
};

export type AggregateDesignLayer = {
  __typename?: 'AggregateDesignLayer';
  count: Scalars['Int'];
};

export type FontWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export type Font = {
  __typename?: 'Font';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
};

export type FontWhereInput = {
  id?: Maybe<Scalars['ID']>;
  id_not?: Maybe<Scalars['ID']>;
  id_in?: Maybe<Array<Scalars['ID']>>;
  id_not_in?: Maybe<Array<Scalars['ID']>>;
  id_lt?: Maybe<Scalars['ID']>;
  id_lte?: Maybe<Scalars['ID']>;
  id_gt?: Maybe<Scalars['ID']>;
  id_gte?: Maybe<Scalars['ID']>;
  id_contains?: Maybe<Scalars['ID']>;
  id_not_contains?: Maybe<Scalars['ID']>;
  id_starts_with?: Maybe<Scalars['ID']>;
  id_not_starts_with?: Maybe<Scalars['ID']>;
  id_ends_with?: Maybe<Scalars['ID']>;
  id_not_ends_with?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAt_not?: Maybe<Scalars['DateTime']>;
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt_lt?: Maybe<Scalars['DateTime']>;
  updatedAt_lte?: Maybe<Scalars['DateTime']>;
  updatedAt_gt?: Maybe<Scalars['DateTime']>;
  updatedAt_gte?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  name_not?: Maybe<Scalars['String']>;
  name_in?: Maybe<Array<Scalars['String']>>;
  name_not_in?: Maybe<Array<Scalars['String']>>;
  name_lt?: Maybe<Scalars['String']>;
  name_lte?: Maybe<Scalars['String']>;
  name_gt?: Maybe<Scalars['String']>;
  name_gte?: Maybe<Scalars['String']>;
  name_contains?: Maybe<Scalars['String']>;
  name_not_contains?: Maybe<Scalars['String']>;
  name_starts_with?: Maybe<Scalars['String']>;
  name_not_starts_with?: Maybe<Scalars['String']>;
  name_ends_with?: Maybe<Scalars['String']>;
  name_not_ends_with?: Maybe<Scalars['String']>;
  AND?: Maybe<Array<FontWhereInput>>;
  OR?: Maybe<Array<FontWhereInput>>;
  NOT?: Maybe<Array<FontWhereInput>>;
};

export enum FontOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
}

export type FontConnection = {
  __typename?: 'FontConnection';
  pageInfo: PageInfo;
  edges: Array<Maybe<FontEdge>>;
  aggregate: AggregateFont;
};

export type FontEdge = {
  __typename?: 'FontEdge';
  node: Font;
  cursor: Scalars['String'];
};

export type AggregateFont = {
  __typename?: 'AggregateFont';
  count: Scalars['Int'];
};

export type Mutation = {
  __typename?: 'Mutation';
  createDesign: Design;
  updateDesign?: Maybe<Design>;
  updateManyDesigns: BatchPayload;
  upsertDesign: Design;
  deleteDesign?: Maybe<Design>;
  deleteManyDesigns: BatchPayload;
  createDesignLayer: DesignLayer;
  updateDesignLayer?: Maybe<DesignLayer>;
  updateManyDesignLayers: BatchPayload;
  upsertDesignLayer: DesignLayer;
  deleteDesignLayer?: Maybe<DesignLayer>;
  deleteManyDesignLayers: BatchPayload;
  createFont: Font;
  updateFont?: Maybe<Font>;
  updateManyFonts: BatchPayload;
  upsertFont: Font;
  deleteFont?: Maybe<Font>;
  deleteManyFonts: BatchPayload;
};

export type MutationCreateDesignArgs = {
  data: DesignCreateInput;
};

export type MutationUpdateDesignArgs = {
  data: DesignUpdateInput;
  where: DesignWhereUniqueInput;
};

export type MutationUpdateManyDesignsArgs = {
  data: DesignUpdateManyMutationInput;
  where?: Maybe<DesignWhereInput>;
};

export type MutationUpsertDesignArgs = {
  where: DesignWhereUniqueInput;
  create: DesignCreateInput;
  update: DesignUpdateInput;
};

export type MutationDeleteDesignArgs = {
  where: DesignWhereUniqueInput;
};

export type MutationDeleteManyDesignsArgs = {
  where?: Maybe<DesignWhereInput>;
};

export type MutationCreateDesignLayerArgs = {
  data: DesignLayerCreateInput;
};

export type MutationUpdateDesignLayerArgs = {
  data: DesignLayerUpdateInput;
  where: DesignLayerWhereUniqueInput;
};

export type MutationUpdateManyDesignLayersArgs = {
  data: DesignLayerUpdateManyMutationInput;
  where?: Maybe<DesignLayerWhereInput>;
};

export type MutationUpsertDesignLayerArgs = {
  where: DesignLayerWhereUniqueInput;
  create: DesignLayerCreateInput;
  update: DesignLayerUpdateInput;
};

export type MutationDeleteDesignLayerArgs = {
  where: DesignLayerWhereUniqueInput;
};

export type MutationDeleteManyDesignLayersArgs = {
  where?: Maybe<DesignLayerWhereInput>;
};

export type MutationCreateFontArgs = {
  data: FontCreateInput;
};

export type MutationUpdateFontArgs = {
  data: FontUpdateInput;
  where: FontWhereUniqueInput;
};

export type MutationUpdateManyFontsArgs = {
  data: FontUpdateManyMutationInput;
  where?: Maybe<FontWhereInput>;
};

export type MutationUpsertFontArgs = {
  where: FontWhereUniqueInput;
  create: FontCreateInput;
  update: FontUpdateInput;
};

export type MutationDeleteFontArgs = {
  where: FontWhereUniqueInput;
};

export type MutationDeleteManyFontsArgs = {
  where?: Maybe<FontWhereInput>;
};

export type DesignCreateInput = {
  id?: Maybe<Scalars['ID']>;
  type: DesignType;
  layers?: Maybe<DesignLayerCreateManyWithoutDesignInput>;
  dimensions: Dimension;
  digitalSize: Dimension;
};

export type DesignLayerCreateManyWithoutDesignInput = {
  create?: Maybe<Array<DesignLayerCreateWithoutDesignInput>>;
  connect?: Maybe<Array<DesignLayerWhereUniqueInput>>;
};

export type DesignLayerCreateWithoutDesignInput = {
  id?: Maybe<Scalars['ID']>;
  type: DesignLayerType;
  attributes: Scalars['Json'];
  position: Point3D;
  dimensions: Dimension;
  image?: Maybe<Scalars['Upload']>;
};

export type Point3D = {
  x: Scalars['Float'];
  y: Scalars['Float'];
  z?: Maybe<Scalars['Int']>;
};

export type Dimension = {
  width: Scalars['Float'];
  height: Scalars['Float'];
  dpi?: Maybe<Scalars['Float']>;
};

export type DesignUpdateInput = {
  type?: Maybe<DesignType>;
  layers?: Maybe<DesignLayerUpdateManyWithoutDesignInput>;
  dimensions?: Maybe<Dimension>;
  digitalSize?: Maybe<Dimension>;
};

export type DesignLayerUpdateManyWithoutDesignInput = {
  create?: Maybe<Array<DesignLayerCreateWithoutDesignInput>>;
  delete?: Maybe<Array<DesignLayerWhereUniqueInput>>;
  connect?: Maybe<Array<DesignLayerWhereUniqueInput>>;
  set?: Maybe<Array<DesignLayerWhereUniqueInput>>;
  disconnect?: Maybe<Array<DesignLayerWhereUniqueInput>>;
  update?: Maybe<Array<DesignLayerUpdateWithWhereUniqueWithoutDesignInput>>;
  upsert?: Maybe<Array<DesignLayerUpsertWithWhereUniqueWithoutDesignInput>>;
  deleteMany?: Maybe<Array<DesignLayerScalarWhereInput>>;
  updateMany?: Maybe<Array<DesignLayerUpdateManyWithWhereNestedInput>>;
};

export type DesignLayerUpdateWithWhereUniqueWithoutDesignInput = {
  where: DesignLayerWhereUniqueInput;
  data: DesignLayerUpdateWithoutDesignDataInput;
};

export type DesignLayerUpdateWithoutDesignDataInput = {
  type?: Maybe<DesignLayerType>;
  attributes?: Maybe<Scalars['Json']>;
  position?: Maybe<Point3D>;
  dimensions?: Maybe<Dimension>;
  image?: Maybe<Scalars['Upload']>;
};

export type DesignLayerUpsertWithWhereUniqueWithoutDesignInput = {
  where: DesignLayerWhereUniqueInput;
  update: DesignLayerUpdateWithoutDesignDataInput;
  create: DesignLayerCreateWithoutDesignInput;
};

export type DesignLayerScalarWhereInput = {
  id?: Maybe<Scalars['ID']>;
  id_not?: Maybe<Scalars['ID']>;
  id_in?: Maybe<Array<Scalars['ID']>>;
  id_not_in?: Maybe<Array<Scalars['ID']>>;
  id_lt?: Maybe<Scalars['ID']>;
  id_lte?: Maybe<Scalars['ID']>;
  id_gt?: Maybe<Scalars['ID']>;
  id_gte?: Maybe<Scalars['ID']>;
  id_contains?: Maybe<Scalars['ID']>;
  id_not_contains?: Maybe<Scalars['ID']>;
  id_starts_with?: Maybe<Scalars['ID']>;
  id_not_starts_with?: Maybe<Scalars['ID']>;
  id_ends_with?: Maybe<Scalars['ID']>;
  id_not_ends_with?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdAt_not?: Maybe<Scalars['DateTime']>;
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  updatedAt_lt?: Maybe<Scalars['DateTime']>;
  updatedAt_lte?: Maybe<Scalars['DateTime']>;
  updatedAt_gt?: Maybe<Scalars['DateTime']>;
  updatedAt_gte?: Maybe<Scalars['DateTime']>;
  type?: Maybe<DesignLayerType>;
  type_not?: Maybe<DesignLayerType>;
  type_in?: Maybe<Array<DesignLayerType>>;
  type_not_in?: Maybe<Array<DesignLayerType>>;
  image?: Maybe<Scalars['String']>;
  image_not?: Maybe<Scalars['String']>;
  image_in?: Maybe<Array<Scalars['String']>>;
  image_not_in?: Maybe<Array<Scalars['String']>>;
  image_lt?: Maybe<Scalars['String']>;
  image_lte?: Maybe<Scalars['String']>;
  image_gt?: Maybe<Scalars['String']>;
  image_gte?: Maybe<Scalars['String']>;
  image_contains?: Maybe<Scalars['String']>;
  image_not_contains?: Maybe<Scalars['String']>;
  image_starts_with?: Maybe<Scalars['String']>;
  image_not_starts_with?: Maybe<Scalars['String']>;
  image_ends_with?: Maybe<Scalars['String']>;
  image_not_ends_with?: Maybe<Scalars['String']>;
  AND?: Maybe<Array<DesignLayerScalarWhereInput>>;
  OR?: Maybe<Array<DesignLayerScalarWhereInput>>;
  NOT?: Maybe<Array<DesignLayerScalarWhereInput>>;
};

export type DesignLayerUpdateManyWithWhereNestedInput = {
  where: DesignLayerScalarWhereInput;
  data: DesignLayerUpdateManyDataInput;
};

export type DesignLayerUpdateManyDataInput = {
  type?: Maybe<DesignLayerType>;
  position?: Maybe<Scalars['Json']>;
  dimensions?: Maybe<Scalars['Json']>;
  attributes?: Maybe<Scalars['Json']>;
  image?: Maybe<Scalars['String']>;
};

export type DesignUpdateManyMutationInput = {
  type?: Maybe<DesignType>;
  dimensions?: Maybe<Scalars['Json']>;
  digitalSize?: Maybe<Scalars['Json']>;
};

export type BatchPayload = {
  __typename?: 'BatchPayload';
  count: Scalars['Long'];
};

export type DesignLayerCreateInput = {
  id?: Maybe<Scalars['ID']>;
  design: DesignCreateOneWithoutLayersInput;
  type: DesignLayerType;
  attributes: Scalars['Json'];
  position: Point3D;
  dimensions: Dimension;
  image?: Maybe<Scalars['Upload']>;
};

export type DesignCreateOneWithoutLayersInput = {
  create?: Maybe<DesignCreateWithoutLayersInput>;
  connect?: Maybe<DesignWhereUniqueInput>;
};

export type DesignCreateWithoutLayersInput = {
  id?: Maybe<Scalars['ID']>;
  type: DesignType;
  dimensions: Scalars['Json'];
  digitalSize: Scalars['Json'];
};

export type DesignLayerUpdateInput = {
  design?: Maybe<DesignUpdateOneRequiredWithoutLayersInput>;
  type?: Maybe<DesignLayerType>;
  position?: Maybe<Scalars['Json']>;
  dimensions?: Maybe<Scalars['Json']>;
  attributes?: Maybe<Scalars['Json']>;
  image?: Maybe<Scalars['String']>;
};

export type DesignUpdateOneRequiredWithoutLayersInput = {
  create?: Maybe<DesignCreateWithoutLayersInput>;
  update?: Maybe<DesignUpdateWithoutLayersDataInput>;
  upsert?: Maybe<DesignUpsertWithoutLayersInput>;
  connect?: Maybe<DesignWhereUniqueInput>;
};

export type DesignUpdateWithoutLayersDataInput = {
  type?: Maybe<DesignType>;
  dimensions?: Maybe<Scalars['Json']>;
  digitalSize?: Maybe<Scalars['Json']>;
};

export type DesignUpsertWithoutLayersInput = {
  update: DesignUpdateWithoutLayersDataInput;
  create: DesignCreateWithoutLayersInput;
};

export type DesignLayerUpdateManyMutationInput = {
  type?: Maybe<DesignLayerType>;
  position?: Maybe<Scalars['Json']>;
  dimensions?: Maybe<Scalars['Json']>;
  attributes?: Maybe<Scalars['Json']>;
  image?: Maybe<Scalars['String']>;
};

export type FontCreateInput = {
  id?: Maybe<Scalars['ID']>;
  name: Scalars['String'];
};

export type FontUpdateInput = {
  name?: Maybe<Scalars['String']>;
};

export type FontUpdateManyMutationInput = {
  name?: Maybe<Scalars['String']>;
};
